export default () => {
    window.youtubeServiceID = 'BJz7qNsdj-7';
    window.gmapsServiceID   = 'S1pcEj_jZX';
    document.addEventListener("DOMContentLoaded", function() {
        if (window.UC_UI && window.UC_UI.isInitialized()) {
            checkConsentStatusForYouTube();
        } else {
            window.addEventListener('UC_UI_INITIALIZED', function (e) {
                checkConsentStatusForYouTube();
            });
        }
        ucEventListener();
    })
}
 
//Prüfe Consent
function checkConsentStatusForYouTube() {
    if (UC_UI.getServicesBaseInfo().find(service => service.name === "YouTube Video").consent.status) {
        setYoutubeIFrame();
    }
}

function checkConsentStatusForGoogleMaps() {
    if (UC_UI.getServicesBaseInfo().find(service => service.name === "Google Maps").consent.status) {
        loadGoogleMaps();
    }
}

function ucEventListener() {
    window.addEventListener("ucEvent", function (e) {
        console.log(e)
        if (e.detail && e.detail.event == "consent_status") {
            if (e.detail['YouTube Video'] === true) {
                //Consent, rendere YouTube Video
                setYoutubeIFrame();
            }
            if (e.detail['Google Maps'] === true) {
                //Consent, rendere YouTube Video
                loadGoogleMaps();
            }
        }
    });
}

/**
 * 
 * if Youtube is Accepted, set IFrame SRC to load Content
 */
function setYoutubeIFrame() {
    removeYoutubeGDPR();
    jQuery('iframe[id^="youtube-item-"]').each( function(i) {
        jQuery(this).attr("src", jQuery(this).data("src")); 
    })
    jQuery('img[id^="youtubeshorts"]').each( function(i) {
        jQuery(this).attr("src", jQuery(this).data("src")); 
    })
    jQuery('div[class^="elementor-custom-embed-image-overlay"]').each( function(i) {
        const imageUrl = jQuery(this).data("src")
        jQuery(this).css('background-image', 'url(' + imageUrl + ')');
    })
}

/**
 * removeYoutube GDPR
 */
function removeYoutubeGDPR(){
    jQuery('div[id^="youtube-gdpr-"]').each( function(i) {
        jQuery(this).addClass('hidden')
    })
}


/**
 * 
 * if googlemaps is Accepted, add div tag and laod
 */
 function loadGoogleMaps() {
//     const existingScript = document.getElementById('google');
    
//     if (!existingScript) {
//         const script = document.createElement('script');
//         script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBoQjgQRlUQVrQtcbKgpWrsACHmQG31QMU&libraries=&v=weekly';
//         script.id = 'google';
//         document.body.appendChild(script);
    
//         script.onload = () => {
//         initMap();
//         };
//     }

//     removeGoogleMapsGDPR();
}

/**
 * removeYoutube GDPR
 */
function removeGoogleMapsGDPR(){
    jQuery('div[id^="googlemaps-gdpr-"]').each( function(i) {
        jQuery(this).addClass('hidden')
    })
}